// Deployment configuration - injected at build time
export const DEPLOYMENT_CONFIG = {
  type: 'singleapp-private',
  defaultApp: 'project750k',
  apiUrl: 'https://pvagnwvqv6.execute-api.us-east-1.amazonaws.com/prod'
};
